
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"70","height":"69","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"3","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M35 66.916c-8.985 0-17.119-3.642-23.006-9.53-5.888-5.89-9.53-14.025-9.53-23.011 0-8.986 3.642-17.121 9.53-23.01C17.88 5.476 26.015 1.834 35 1.834s17.119 3.642 23.006 9.53c5.888 5.89 9.53 14.025 9.53 23.011 0 8.986-3.642 17.121-9.53 23.01C52.12 63.274 43.985 66.916 35 66.916z","stroke":"#FFE86C"}}),_c('path',{attrs:{"stroke":"#005149","stroke-linecap":"round","d":"M26.072 25.524L43.928 43.38m0-18.005L26.072 43.231"}})])])
          )
        }
      }
    